import Ably from 'ably';

// Ensure Vercel doesn't cache the result of this route,
// as otherwise the token request data will eventually become outdated
// and we won't be able to authenticate on client side
export const revalidate = 0;

/**
 * Creates a token request handler for Ably authentication.
 * This function initializes an Ably REST client and generates a token request
 * using the provided API key from environment variables.
 *
 * @async
 * @returns {Promise<Response>} A Response object containing either the token request data
 * or an error message with a 500 status code.
 * @throws {Error} If NEXT_PUBLIC_STOODIO_ABLY_KEY is not defined in environment variables.
 */
export async function createRequestTokenDataHandler() {
  const apiKey = process.env.NEXT_PUBLIC_STOODIO_ABLY_KEY;

  if (!apiKey) {
    throw new Error('NEXT_PUBLIC_STOODIO_ABLY_KEY is not defined');
  }

  try {
    const client = new Ably.Rest(apiKey);
    const tokenRequestData = await client.auth.createTokenRequest();
    return Response.json(tokenRequestData);
  } catch (error) {
    console.error('Error creating Ably token request:', error);
    return Response.json(
      { error: 'Failed to create token request' },
      { status: 500 },
    );
  }
}

/**
 * Default wrapper for the token request handler.
 * This function serves as the default export for creating Ably token requests,
 * making it easier to maintain consistent token request handling across the application.
 *
 * @returns {Promise<Response>} A Response object from createRequestTokenDataHandler
 */
export const createDefaultRequestTokenDataHandler = () => {
  return createRequestTokenDataHandler();
};
